export default "__VITE_ASSET__BweJbPja__"